var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"play-button",class:{'play-button--paused': _vm.isPlaying},on:{"click":function($event){return _vm.onToggle()}}},[_c('span',{staticClass:"play-button__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }